import type {
  ResendInviteRequestBody,
  ResendInviteResponseBody,
  SendInviteRequestBody,
  SendInviteResponseBody,
  SupplierGroupMember,
  UpdateTeamMemberRequestBody,
} from '@frontend/api';

export const UPDATE_TEAM_MEMBER_REQUEST =
  'supplier/UPDATE_TEAM_MEMBER_REQUEST' as const;
export const UPDATE_TEAM_MEMBER_SUCCESS =
  'supplier/UPDATE_TEAM_MEMBER_SUCCESS' as const;
export const UPDATE_TEAM_MEMBER_ERROR =
  'supplier/UPDATE_TEAM_MEMBER_ERROR' as const;

export const CREATE_TEAM_MEMBER_REQUEST =
  'supplier/CREATE_TEAM_MEMBER_REQUEST' as const;
export const CREATE_TEAM_MEMBER_SUCCESS =
  'supplier/CREATE_TEAM_MEMBER_SUCCESS' as const;
export const CREATE_TEAM_MEMBER_ERROR =
  'supplier/CREATE_TEAM_MEMBER_ERROR' as const;

export const DELETE_TEAM_MEMBER_REQUEST =
  'supplier/DELETE_TEAM_MEMBER_REQUEST' as const;
export const DELETE_TEAM_MEMBER_SUCCESS =
  'supplier/DELETE_TEAM_MEMBER_SUCCESS' as const;
export const DELETE_TEAM_MEMBER_ERROR =
  'supplier/DELETE_TEAM_MEMBER_ERROR' as const;

export const GET_TEAM_MEMBERS_REQUEST =
  'supplier/GET_TEAM_MEMBERS_REQUEST' as const;
export const GET_TEAM_MEMBERS_SUCCESS =
  'supplier/GET_TEAM_MEMBERS_SUCCESS' as const;
export const GET_TEAM_MEMBERS_ERROR =
  'supplier/GET_TEAM_MEMBERS_ERROR' as const;

export const GET_TEAM_MEMBER_SUCCESS =
  'supplier/GET_TEAM_MEMBER_SUCCESS' as const;
export const GET_TEAM_MEMBER_ERROR = 'supplier/GET_TEAM_MEMBER_ERROR' as const;

export const CREATE_TEAM_MEMBER = 'supplier/CREATE_TEAM_MEMBER' as const;

export const TEAM_MEMBER_INVITE_RESEND_REQUEST =
  'supplier/TEAM_MEMBER_RESEND_REQUEST' as const;
export const TEAM_MEMBER_INVITE_RESEND_ERROR =
  'supplier/TEAM_MEMBER_RESEND_ERROR' as const;
export const TEAM_MEMBER_INVITE_RESEND_SUCCESS =
  'supplier/TEAM_MEMBER_RESEND_SUCCESS' as const;

export const SEND_VERIFICATION_EMAIL_REQUEST =
  'supplier/SEND_VERIFICATION_EMAIL_REQUEST' as const;
export const SEND_VERIFICATION_EMAIL_SUCCESS =
  'supplier/SEND_VERIFICATION_EMAIL_SUCCESS' as const;
export const SEND_VERIFICATION_EMAIL_ERROR =
  'supplier/SEND_VERIFICATION_EMAIL_ERROR' as const;

export const CHECK_EMAIL_VERIFICATION_REQUEST =
  'supplier/CHECK_EMAIL_VERIFICATION_REQUEST' as const;
export const CHECK_EMAIL_VERIFICATION_SUCCESS =
  'supplier/CHECK_EMAIL_VERIFICATION_SUCCESS' as const;
export const CHECK_EMAIL_VERIFICATION_ERROR =
  'supplier/CHECK_EMAIL_VERIFICATION_ERROR' as const;

/** returned by the getTeamMembers selector, which merges in the active group's invite */
export type TeamMemberWithInviteStatus = SupplierGroupMember & {
  isInviteAccepted?: boolean;
  isInviteExpired?: boolean;
};

export type SupplierState = {
  /** `{}` until a team member is loaded, and while creating a new one */
  activeTeamMember: Partial<SupplierGroupMember>;
  /** null while a verification check is in flight */
  isActiveTeamMemberEmailVerified: boolean | null;
  isEmailResendFetching: boolean;
  isCreatingTeamMember: boolean;
  teamMembers: SupplierGroupMember[];
};

export type ErrorPayload = {
  error: unknown;
};

export type TeamMembersPayload = {
  teamMembers: SupplierGroupMember[];
};

export type TeamMemberPayload = {
  teamMember: SupplierGroupMember;
};

export type TeamMemberIdPayload = {
  teamMemberId: number;
};

export type CreateTeamMemberRequestPayload = {
  teamMember: SendInviteRequestBody;
};

export type CreateTeamMemberSuccessPayload = {
  response: SendInviteResponseBody;
};

export type UpdateTeamMemberRequestPayload = {
  teamMember: UpdateTeamMemberRequestBody &
    Pick<SupplierGroupMember, 'id' | 'email'>;
  cb?: () => void;
};

export type ResendInviteRequestPayload = ResendInviteRequestBody;

export type ResendInviteSuccessPayload = {
  response: ResendInviteResponseBody;
};

export type CheckEmailVerificationSuccessPayload = {
  isVerified: boolean;
};
